import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeResoveService } from './home/home-service/home-resolve.service';
import { ContentResoveService } from './home/home-service/contetn-resolve.service';
import { Stripev3ResolverService } from './home/shared-layout/user/billing-payment/stripev3/stripev3-resolver.service';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
        resolve: {
            settings:HomeResoveService,
            content: ContentResoveService,
            stripe_resource: Stripev3ResolverService
        }
    },
    {
        path: 'client',
        loadChildren: () => import('./client/client.module').then(m => m.ClientModule),
        resolve: {
            settings:HomeResoveService,
            content: ContentResoveService
        }
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [HomeResoveService]
})
export class AppRoutingModule { }
